module.exports = __webpack_public_path__ + "img/600px-LinkedIn_logo_initials.4c9e2aab.png";